import React from 'react';

interface ConditionalProps {
  condition: any | (() => any);
  children: React.ReactNode;
}

/**
 * Replaces `{condition && <Component />}` pattern.
 *
 * @example
 * <Conditional condition={() => true}>
 *   <div>Hello, world!</div>
 * </Conditional>
 *
 * @example
 * <Conditional condition={[].length]}>
 *   <div>Hello, world!</div>
 * </Conditional>
 */
export const Conditional = ({ condition, children }: ConditionalProps) => {
  const conditionValue = typeof condition === 'function' ? condition() : condition;
  const isConditionMet = Boolean(conditionValue);

  if (isConditionMet) {
    return <>{children}</>;
  }

  return null;
};
